// extracted by mini-css-extract-plugin
export default {"content":"_3xB_g","benefits":"_3bpyR"};